import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { ActiveParagraphColor } from "../../pages/Theme";
import Tooltip from "@mui/material/Tooltip";

const JournalHashtag = ({ text, color, onClick, style, fullTitle = null }) => {
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  return isDefaultTheme == true ? (
    <Tooltip title={fullTitle ? fullTitle : text} placement="top" arrow>
      <button
        className={`flex flex-row bg-${color}-light hover:opacity-80 rounded-md px-2 py-1 
                        items-center justify-center w-flex ${style}`}
        onClick={onClick}
      >
        <p className={`text-${color}-dark font-semibold text-xs`}>{text}</p>
      </button>
    </Tooltip>
  ) : (
    <Tooltip title={fullTitle ? fullTitle : text} placement="top" arrow>
      <button
        className={`flex flex-row bg-${color}-light hover:opacity-80 rounded-md px-2 py-1 
                    items-center justify-center w-flex ${style}`}
        onClick={onClick}
      >
        <ActiveParagraphColor className={`font-semibold text-xs`}>
          {text}
        </ActiveParagraphColor>
      </button>
    </Tooltip>
  );
};

JournalHashtag.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  url: PropTypes.string,
};

export default JournalHashtag;
